<template>
  <div id="listadolicenciasregistradas">
    <div v-show="!licenses.length">
      <div class="ui icon warning message">
        <i class="user icon"></i>
        <div class="content">
          <div class="header">
            {{ $t("components.registeredLicenses.No_hay_licencias") }}
          </div>
          <p>{{ $t("components.registeredLicenses.Aniade_con_boton_registrar") }}</p>
        </div>
      </div>
    </div>

    <table v-if="licenses.length" id="table-licenses" class="ui compact celled definition table selectable sortable">
      <thead class="full-width">
        <tr>
          <th class="seven wide">{{ $t("components.registeredLicenses.Descripcion") }}</th>
          <th class="center aligned five wide">{{ $t("components.registeredLicenses.Codigo_licencia") }}</th>
          <th class="center aligned three wide">{{ $t("components.registeredLicenses.Activado") }}</th>
          <th class="one wide no-sort"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="license in licenses" v-bind:key="license._id">
          <td style="font-size: 16px;">{{ license.description }}</td>
          <td class="center aligned">{{ license.licenseCode }}</td>
          <td class="center aligned" :class="{ negative : !getActivationDateLicense(license), positive: getActivationDateLicense(license) }">
            <div class="ui accordion" v-if="getActivationDateLicense(license)">
              <div class="title">
                <i class="icon" :class="{ checkmark: getActivationDateLicense(license), close: !getActivationDateLicense(license) }"></i>
              </div>
              <div class="left aligned content">
                <p class="transition visible" style="display: block !important;">
                  <strong>{{ getTextoActivationDateLicense(license) }}</strong>
                </p>
              </div>
            </div>
            <i class="icon" v-if="!getActivationDateLicense(license)" :class="{ checkmark: getActivationDateLicense(license), close: !getActivationDateLicense(license) }"></i>
          </td>
          <td class="right aligned collapsing">
            <div class="ui icon buttons mini">
              <router-link class="item" :to="'/license/' + license._id">
                <button class="ui button" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Boton_editar')" data-position="bottom center">
                  <i class="pencil alternate icon"></i>
                </button>
              </router-link>
              <button class="ui button" v-if="getActivationDateLicense(license)" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Boton_desactivar')" data-position="bottom center" @click="deactivateLicense(license._id)">
                <i class="redo icon"></i>
              </button>
              <button class="ui red button" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Boton_borrar')" data-position="bottom center" @click="deleteLicense(license._id)">
                <i class="times icon"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="4">
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Registrar_nuevo')" data-position="bottom center" style="float:right" @click="newLicense">
              <i class="icon plus"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Exportar_excel')" data-position="bottom center" style="float:right" @click="exportTableToExcel">
              <i class="icon file excel"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Exportar_pdf')" data-position="bottom center" style="float:right" @click="exportTableToPdf">
              <i class="icon file pdf"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.registeredLicenses.Buscar')" data-position="bottom center" style="float:right" @click="search">
              <i class="icon sync alternate"></i>
            </button>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import XLSX from 'xlsx';

export default {
  name: 'RegisteredLicenses',
  data: function () {
    return {
      licenses: [],
      moment: Vue.moment
    };
  },
  methods: {
    newLicense: function () {
      this.$router.push({ name: 'newlicense' });
    },
    exportTableToPdf: function () {
      const jsPDFInstance = new JsPDF();
      jsPDFInstance.autoTable({ html: '#table-licenses' });
      jsPDFInstance.save(this.$i18n.t('components.registeredLicenses.Fichero_export_nombre') + this.moment().locale(this.$i18n.locale).format('YYYYMMDDHHmmss') + '.pdf');
    },
    exportTableToExcel: function () {
      let data = XLSX.utils.table_to_sheet(document.getElementById('table-licenses'));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, data, this.$i18n.t('components.registeredLicenses.Excel_export_nombre_hoja'));
      XLSX.writeFile(workbook, this.$i18n.t('components.registeredLicenses.Fichero_export_nombre') + this.moment().locale(this.$i18n.locale).format('YYYYMMDDHHmmss') + '.xlsx');
    },
    search: function () {
      this.refresh();

      setTimeout(() => {
        $('#listadolicenciasregistradas .accordion').accordion({
          selector: {
            trigger: '.title'
          }
        });
      }, 500);
    },
    refresh: function () {
      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/license').then(response => {
        if (response) {
          this.licenses = response.data.licenses;

          if (this.licenses.length === 0) {
            $("#table-licenses_wrapper").hide();
          } else {
            $("#table-licenses_wrapper").show();
          }
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.registeredLicenses.Hay_un_error'),
          text: e
        });
      });
    },
    getActivationDateLicense: function (license) {
      if (license == null) return false;
      if (!license.activationDate) return false;
      return true;
    },
    getTextoActivationDateLicense: function (license) {
      if (license.activationDate != null) {
        return this.$i18n.t('components.registeredLicenses.Activado_el') + this.moment(license.activationDate).locale(this.$i18n.locale).format('LLLL');
      } else {
        return "";
      }
    },
    deactivateLicense: function (idLicense) {
      this.$swal.fire({
        title: this.$i18n.t('components.registeredLicenses.Esta_seguro'),
        text: this.$i18n.t('components.registeredLicenses.Se_desactivara'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$i18n.t('components.common.Si'),
        cancelButtonText: this.$i18n.t('components.common.No')
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.put('/license/' + idLicense, { _id: idLicense, activationDate: null }).then(response => {
            this.$swal.fire(
              this.$i18n.t('components.registeredLicenses.Desactivado'),
              this.$i18n.t('components.registeredLicenses.Se_ha_desactivado'),
              'success'
            );
            setTimeout(() => {
              this.refresh();
            }, 500);
          }).catch(e => {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.registeredLicenses.Hay_un_error'),
              text: e
            });
          });
        }
      });
    },
    deleteLicense: function (idLicense) {
      this.$swal.fire({
        title: this.$i18n.t('components.registeredLicenses.Esta_seguro'),
        text: this.$i18n.t('components.registeredLicenses.Se_borrara'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$i18n.t('components.common.Si'),
        cancelButtonText: this.$i18n.t('components.common.No')
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.delete('/license/' + idLicense).then(response => {
            this.$swal.fire(
              this.$i18n.t('components.registeredLicenses.Borrado'),
              this.$i18n.t('components.registeredLicenses.Se_ha_borrado'),
              'success'
            );
            setTimeout(() => {
              this.refresh();
            }, 500);
          }).catch(e => {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.registeredLicenses.Hay_un_error'),
              text: e
            });
          });
        }
      });
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('table').DataTable({
        language: this.$i18n.t('components.datatable_language')
      })
      .on('draw', () => {
        $('#listadolicenciasregistradas .accordion').accordion({
          selector: {
            trigger: '.title'
          }
        });
      });

      $('#listadolicenciasregistradas .accordion').accordion({
        selector: {
          trigger: '.title'
        }
      });
    }, 500);
  }
};
</script>
